<p>
  Ако искате временно да прекратите активността на дадена обява, без да я изтривате, може да я <strong>спрете</strong>.
  Спряната обява няма да бъде видима за останалите потребители и те няма да могат да я купуват или да участват в
  наддавания за нея.
</p>
<h6 class="mt-3">Начини за спиране на обява:</h6>
<ul>
  <li>
    <strong>От страницата на обявата</strong> – Отворете страницата на вашата обява, изберете бутона
    <strong>„Още действия“</strong> и след това изберете <strong>„Спиране на обявата“</strong>.
  </li>
  <li>
    <strong>От вашия профил:</strong> Отидете в секцията <strong>„Профил“ → „Моите обяви“</strong>, намерете обявата,
    която искате да спрете, натиснете бутона с <strong>трите точки (⋮)</strong> в десния горен ъгъл и изберете
    <strong>„Спиране на обявата“</strong>.
  </li>
</ul>
<h6 class="mt-3">Какво става след спиране на обявата?</h6>
<p>
  След като бъде спряна, обявата нема да бъде видима за останалите потребители, но няма да бъде изтрита от платформата.
  Вие ще може да я видите във вашия профил със статус <strong>„Обява завършила без сделка“</strong>.
</p>
<p>
  Имате възможност да възстановите активността на спряната обява по всяко време чрез бутона за
  <strong>„Обновяване на обявата“</strong>.
</p>
<div class="alert alert-primary m-0">
  <strong>Съвет:</strong> Използвайте опцията за спиране на обява, когато временно не желаете да продавате артикула, но
  искате да го запазите за бъдеща продажба без да губите въведената информация.
</div>
